import { Components, Theme } from '@mui/material';

const muiInputLabel: Components<Theme>['MuiInputLabel'] = {
	styleOverrides: {
		root: ({ theme }) => ({
			...theme.typography.input,
			lineHeight: 'auto',
		}),
		outlined: {
			opacity: 0.4,
			'&.MuiInputLabel-shrink': {
				opacity: 1,
			},
		},
		// This works in tandem with
		sizeSmall: {
			top: 3,
			'&.MuiInputLabel-shrink': {
				top: 1,
			},
		},
	},
};

export default muiInputLabel;
